var menuButton = document.querySelector('.mobile-menu__button--burger');
var hamburger = document.getElementById('hamburger');
var closeButton = document.querySelector('.drawer__close-button');

if (menuButton) {
  menuButton.addEventListener('click', function(e) {
    setTimeout(function() {
      var expanded = menuButton.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        hamburger.classList.add('active');
      } else {
        hamburger.classList.remove('active');
      }
    }, 10);
  });
}

if (closeButton) {
  closeButton.addEventListener('click', function(e) {
    setTimeout(function() {
      hamburger.classList.remove('active');
    }, 10);
  });
}
